import { createSelector } from 'reselect';

export const getTopMenu = (state) => state.topMenu;

export const getInstalledVersions = createSelector(
  getTopMenu,
  (topMenu) => topMenu.installedVersions
);

export const getInstalledVersionsRows = createSelector(
  getTopMenu,
  (topMenu) => topMenu.installedVersions.rows
);
